import useCarouselSettings from '~/hooks/home/useCarouselSettings';
import Carousel from './Carousel';

const MAX_LENGTH = 4;

type OwnProps = {
  includeSubHeader?: boolean;
  Tile: React.FC;
};

const CarouselSkeleton = ({ includeSubHeader = false, Tile }: OwnProps) => {
  const { values, carouselRef } = useCarouselSettings({
    subHeading: includeSubHeader ? 'sub header' : '',
    maxLength: MAX_LENGTH,
    isSkeleton: true
  });

  const renderSkeletonTile = (_, idx) => <Tile key={idx} />;

  const skeletons = new Array(MAX_LENGTH).fill('').map(renderSkeletonTile);

  return (
    <Carousel {...values} ref={carouselRef} isSkeleton>
      {skeletons}
    </Carousel>
  );
};

export default CarouselSkeleton;
